// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"f1423c89","435":"a6136dd3","642":"9f94b27e","837":"ca224c7e","939":"4c8342be"}[chunkId] + ".chunk.js";
};